export const fmtHM = (h) => {
  const n = parseFloat(h);
  if (isNaN(n) || n <= 0) return "—";
  const m = Math.round(n * 60);
  const hh = Math.floor(m / 60), mm = m % 60;
  return hh === 0 ? `${mm}m` : mm === 0 ? `${hh}h` : `${hh}h ${mm}m`;
};

export const fmtTime = (t) => t ? new Date(t).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", timeZone: "Asia/Kolkata" }) : "—";

// Ordinal day + short month + year, e.g. "22nd Sep 2026" — matches the web
// app's src/dateFormat.js fmtDMY output.
const MONTH_SHORT = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
function ordinal(n) {
  const rem100 = n % 100;
  if (rem100 >= 11 && rem100 <= 13) return `${n}th`;
  switch (n % 10) {
    case 1: return `${n}st`;
    case 2: return `${n}nd`;
    case 3: return `${n}rd`;
    default: return `${n}th`;
  }
}

export const fmtDate = (d) => {
  if (!d) return "—";
  const dt = new Date(d + "T12:00:00");
  if (isNaN(dt)) return "—";
  return `${ordinal(dt.getDate())} ${MONTH_SHORT[dt.getMonth()]} ${dt.getFullYear()}`;
};

export const fmtMonthDay = (md) => {
  if (!md || md.length < 5) return "";
  const d = new Date("2000-" + md + "T12:00:00");
  if (isNaN(d)) return md;
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short" });
};

export const fmtAnnouncementDate = (v) => {
  if (!v) return "";
  const s = typeof v === "string" ? v : String(v);
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) {
    const d = new Date(s.slice(0, 10) + "T12:00:00");
    if (!isNaN(d)) return `${ordinal(d.getDate())} ${MONTH_SHORT[d.getMonth()]} ${d.getFullYear()}`;
  }
  return s;
};

export const todayStr = () => {
  const d = new Date();
  const ist = new Date(d.getTime() + 5.5 * 3600000);
  return ist.toISOString().slice(0, 10);
};
